import type { Theme } from "@/stores/ui";

/**
 * Apply a theme by toggling the `dark` class, which is what the
 * `@custom-variant dark` rule in index.css keys off.
 *
 * "system" follows the OS preference and keeps following it, so a user who
 * flips their OS to dark mode at dusk sees the app follow without a reload.
 */
export function applyTheme(theme: Theme): () => void {
  const root = document.documentElement;
  const media = window.matchMedia("(prefers-color-scheme: dark)");

  const resolve = () => {
    const dark = theme === "dark" || (theme === "system" && media.matches);
    root.classList.toggle("dark", dark);
    root.style.colorScheme = dark ? "dark" : "light";
  };

  resolve();

  if (theme !== "system") return () => undefined;

  media.addEventListener("change", resolve);
  return () => media.removeEventListener("change", resolve);
}
